var map = {
	"./75Years.png": 2657,
	"./Anatomy-icon-6.png": 6537,
	"./Apo A&B.jpg": 7764,
	"./Awa-amalase.png": 5819,
	"./Awad-vitaminB.png": 2059,
	"./Group 230 (1).png": 5491,
	"./HbA1c.png": 2020,
	"./Pancreatic-new.png": 4374,
	"./SL.jpg": 6610,
	"./accuracy.png": 5812,
	"./advice.png": 5927,
	"./alcohol.png": 7681,
	"./ana-brain.png": 5658,
	"./ana-heart.png": 5634,
	"./ana-kidneys-left.png": 5639,
	"./ana-kidneys-right.png": 2056,
	"./ana-kidneys.png": 3945,
	"./ana-largeintestine.png": 7554,
	"./ana-left-leg.png": 2800,
	"./ana-liver.png": 6974,
	"./ana-lungs.png": 8393,
	"./ana-right-leg.png": 2191,
	"./ana-samllintestine.png": 6770,
	"./ana-stomuch.png": 9181,
	"./ana-thyriod.png": 9513,
	"./analytics.png": 9443,
	"./anatomy-1.png": 698,
	"./anatomy-Head.png": 2581,
	"./anatomy-Heart.png": 3247,
	"./anatomy-female.png": 9683,
	"./anatomy-icon-1.png": 8982,
	"./anatomy-icon-2.png": 3869,
	"./anatomy-icon-3.png": 2740,
	"./anatomy-icon-4.png": 8651,
	"./anatomy-icon-5.png": 7522,
	"./blood-test.png": 3986,
	"./check-up.png": 4901,
	"./color-coded-parameter.png": 7158,
	"./concept-of-medical.jpg": 2355,
	"./critical-paramater.png": 6078,
	"./customer-support.png": 4725,
	"./d-1.png": 9521,
	"./d-2.png": 8938,
	"./d-3.png": 4147,
	"./diet-rec.png": 1596,
	"./disease.png": 2417,
	"./disease1.png": 7436,
	"./dna.png": 9412,
	"./evaluate.png": 4962,
	"./exercise.png": 797,
	"./flask.png": 9198,
	"./glucose-blood.png": 1392,
	"./good-quality.png": 416,
	"./health-medical-scien.jpg": 9058,
	"./health-medical-science-old-2.png": 8327,
	"./health-medical-science-old-3.png": 5310,
	"./health-medical-science-old.jpg": 82,
	"./heart.png": 8559,
	"./historic-trends.png": 6347,
	"./hospital.png": 2593,
	"./i-1.png": 9328,
	"./i-2.png": 6891,
	"./i-3.png": 5346,
	"./i-4.png": 5325,
	"./i-5.png": 2084,
	"./i-6.png": 7359,
	"./ii-1.png": 6451,
	"./ii-10.png": 3883,
	"./ii-14.png": 4351,
	"./ii-2.png": 9592,
	"./ii-3.png": 3457,
	"./ii-4.png": 6718,
	"./ii-5.png": 9207,
	"./ii-6.png": 204,
	"./ii-7.png": 2469,
	"./ii-8.png": 1618,
	"./ii-9.png": 6443,
	"./immediate-su-test.png": 7726,
	"./iron.png": 5721,
	"./kidney-new.png": 278,
	"./kidney.png": 7115,
	"./lifestyle-rec.png": 6515,
	"./lipid-new.png": 414,
	"./lipid.png": 5763,
	"./liver.png": 8171,
	"./logo.png": 2806,
	"./lungs.png": 3656,
	"./medical.png": 2462,
	"./no-drinks.png": 8472,
	"./pancreatitis.png": 4404,
	"./pantagon.png": 907,
	"./quit-smoking.png": 3563,
	"./refresh.png": 7914,
	"./sl-1.png": 716,
	"./smart-report-old.png": 5317,
	"./smart-report.png": 7625,
	"./stress-relief.png": 5689,
	"./time.png": 2968,
	"./understanding.png": 5593,
	"./urinalysis.png": 1632,
	"./vision.png": 2187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3564;